export function setupGoogleTag(doc: Document) {
  doc.head.insertAdjacentHTML("beforeend", `
    <script id="google-scrile-tag" async src="https://www.googletagmanager.com/gtag/js?id=G-2YH6EKM5DJ"></script>
    <script>
      window.dataLayer = window.dataLayer || [];
      function gtag(){ dataLayer.push(arguments); }
      gtag("js", new Date());
      gtag("config", "G-2YH6EKM5DJ", {
        custom_map: { dimension1: "user_role" },
      });
    </script>
  `);
}

export function setupYandexTag(doc: Document) {
  doc.head.insertAdjacentHTML("beforeend", `
    <script id="yandex-tag" async type="text/javascript">
      (function(m, e, t, r, i, k, a) {
        m[i] =
          m[i] ||
          function() {
            (m[i].a = m[i].a || []).push(arguments);
          };
        m[i].l = 1 * new Date();
        (k = e.createElement(t)),
          (a = e.getElementsByTagName(t)[0]),
          (k.async = 1),
          (k.src = r),
          a.parentNode.insertBefore(k, a);
      })(window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");

      ym(56757517, "init", {
        clickmap: true,
        trackLinks: true,
        accurateTrackBounce: true,
        webvisor: true,
      });
    </script>
  `);
}